module.exports = __webpack_public_path__ + "img/pota-messaging.cc3cd0a0.jpg";